import { jsx as _jsx } from "react/jsx-runtime";
import { QRCodeSVG } from "qrcode.react";
import { cn } from "./cn.js";
/** QR code on a white tile (scanners need dark-on-light, even in dark mode). */
export function QrCode({ value, size = 184, label, className, }) {
    return (_jsx("div", { className: cn("inline-flex rounded-card bg-white p-3", className), role: "img", "aria-label": label, children: _jsx(QRCodeSVG, { value: value, size: size, level: "M", marginSize: 0 }) }));
}
//# sourceMappingURL=QrCode.js.map